import { languages } from 'assets/languages'

export const getPathWithoutLocale = (path, supportedLanguages) => {
  const segaments = path.split('/')
  const locale = segaments[1]
  const found = supportedLanguages.find(lang => locale === lang)
  if (found) {
    // Remove 
    segaments.splice(1, 1)
  }
  return segaments.join('/')
}

export const getPathFromLocation = ({pathname}) => getPathWithoutLocale(pathname, languages)


